import { getTalentFullName } from "../../../../../app/common";
import { Talent } from "../../../../../features/talents/talentAPI";
import { TalentStatus } from "../../../../../features/talents/types/common";

export type TalentAutocompleteOption = {
  id: string;
  name: string;
  city?: string;
  talentStatus?: TalentStatus;
};

export const mapTalentToOption = (
  talent: Talent,
): TalentAutocompleteOption => ({
  id: talent.id,
  name: getTalentFullName(talent),
  city: talent.account?.address?.city ?? "",
  talentStatus: talent.account?.status,
});
